import React from 'react';
import { settings } from '../../config/settings';
import ControlService from '../../helper/controlservice';


export const initiateAuth = async (token) => {
    const _control = {
        method: 'post',
        datasource: 'http'
    }
    return await ControlService().ServiceRequest(ControlService().azureFunctionUrl(token) + settings.OAUTH_INITIATE_AUTH_API, {}, _control, token, null)
        .then(res => { return res });
}
export const generateAccessToken = async (token) => {
    const _control = {
        method: 'get',
        datasource: 'http'
    }
    let code = ControlService().GetParamUrl('code');

    let apiParam = {
        'code': code
    }
    return await ControlService().ServiceRequest(ControlService().azureFunctionUrl(token) + settings.OAUTH_ACCESSTOKEN_API, apiParam, _control, token, null)
        .then(res => { return res });
}
export const IsGCloudRegistered = async (token) => {
    const _control = {
        method: 'get',
        datasource: 'http'
    }
    let apiParam = {}
    return await ControlService().ServiceRequest(ControlService().azureFunctionUrl(token) + settings.OAUTH_GCLOUD_STATUS_API, apiParam, _control, token, null)
        .then(res => { return res });
}